module.exports = __webpack_public_path__ + "media/images/icons/outlined/pause-a1887d7d78c6f3c121e90654a6efc51b.svg";